/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * TreePlotter v3 API
 * TreePlotter v3 API
 * OpenAPI spec version: 4.51.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  AdminGetUsersAccessByEmail200,
  AdminGetUsersAccessByEmailParams,
  AdminGetUsersParams,
  BadRequestResponse,
  CreateUser,
  CreateUser201,
  ForbiddenErrorResponse,
  GetUserParams,
  GetUsersParams,
  Id,
  ImportUser,
  SetUserEmail,
  UnauthorizedErrorResponse,
  User,
} from ".././model";

import { httpClient } from "../../../src/common/infrastructure/api/http-client";

export const createUser = (
  userId: Id,
  createUser: CreateUser,
  signal?: AbortSignal
) => {
  return httpClient<CreateUser201 | void>({
    url: `/command-service/identity-and-access/aggregate/user/${userId}/create-user`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createUser,
    signal,
  });
};

export const getCreateUserMutationOptions = <
  TError = void | UnauthorizedErrorResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createUser>>,
    TError,
    { userId: Id; data: CreateUser },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createUser>>,
  TError,
  { userId: Id; data: CreateUser },
  TContext
> => {
  const mutationKey = ["createUser"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createUser>>,
    { userId: Id; data: CreateUser }
  > = (props) => {
    const { userId, data } = props ?? {};

    return createUser(userId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateUserMutationResult = NonNullable<
  Awaited<ReturnType<typeof createUser>>
>;
export type CreateUserMutationBody = CreateUser;
export type CreateUserMutationError = void | UnauthorizedErrorResponse;

export const useCreateUser = <
  TError = void | UnauthorizedErrorResponse,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createUser>>,
      TError,
      { userId: Id; data: CreateUser },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createUser>>,
  TError,
  { userId: Id; data: CreateUser },
  TContext
> => {
  const mutationOptions = getCreateUserMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const importUser = (importUser: ImportUser, signal?: AbortSignal) => {
  return httpClient<void | void>({
    url: `/command-service/identity-and-access/service/cognito-user-import/import-user`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: importUser,
    signal,
  });
};

export const getImportUserMutationOptions = <
  TError = void | UnauthorizedErrorResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof importUser>>,
    TError,
    { data: ImportUser },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof importUser>>,
  TError,
  { data: ImportUser },
  TContext
> => {
  const mutationKey = ["importUser"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof importUser>>,
    { data: ImportUser }
  > = (props) => {
    const { data } = props ?? {};

    return importUser(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ImportUserMutationResult = NonNullable<
  Awaited<ReturnType<typeof importUser>>
>;
export type ImportUserMutationBody = ImportUser;
export type ImportUserMutationError = void | UnauthorizedErrorResponse;

export const useImportUser = <
  TError = void | UnauthorizedErrorResponse,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof importUser>>,
      TError,
      { data: ImportUser },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof importUser>>,
  TError,
  { data: ImportUser },
  TContext
> => {
  const mutationOptions = getImportUserMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get users via tenant id
 */
export const getUsers = (
  tenantId: Id,
  params: GetUsersParams,
  signal?: AbortSignal
) => {
  return httpClient<User[]>({
    url: `/query-service/user-information/tenant/${tenantId}/get-users`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetUsersQueryKey = (tenantId?: Id, params?: GetUsersParams) => {
  return [
    "query-service",
    "user-information",
    "tenant",
    tenantId,
    "get-users",
    ...(params ? [params] : []),
  ] as const;
};

export const getGetUsersQueryOptions = <
  TData = Awaited<ReturnType<typeof getUsers>>,
  TError = UnauthorizedErrorResponse | void
>(
  tenantId: Id,
  params: GetUsersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUsers>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetUsersQueryKey(tenantId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getUsers>>> = ({
    signal,
  }) => getUsers(tenantId, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!tenantId,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getUsers>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type GetUsersQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUsers>>
>;
export type GetUsersQueryError = UnauthorizedErrorResponse | void;

export function useGetUsers<
  TData = Awaited<ReturnType<typeof getUsers>>,
  TError = UnauthorizedErrorResponse | void
>(
  tenantId: Id,
  params: GetUsersParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUsers>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUsers>>,
          TError,
          Awaited<ReturnType<typeof getUsers>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUsers<
  TData = Awaited<ReturnType<typeof getUsers>>,
  TError = UnauthorizedErrorResponse | void
>(
  tenantId: Id,
  params: GetUsersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUsers>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUsers>>,
          TError,
          Awaited<ReturnType<typeof getUsers>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUsers<
  TData = Awaited<ReturnType<typeof getUsers>>,
  TError = UnauthorizedErrorResponse | void
>(
  tenantId: Id,
  params: GetUsersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUsers>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get users via tenant id
 */

export function useGetUsers<
  TData = Awaited<ReturnType<typeof getUsers>>,
  TError = UnauthorizedErrorResponse | void
>(
  tenantId: Id,
  params: GetUsersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUsers>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetUsersQueryOptions(tenantId, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Retrieve information about a user for user JWT.
 * @summary Get user
 */
export const getUser = (params: GetUserParams, signal?: AbortSignal) => {
  return httpClient<User>({
    url: `/query-service/user-information/get-user`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetUserQueryKey = (params?: GetUserParams) => {
  return [
    "query-service",
    "user-information",
    "get-user",
    ...(params ? [params] : []),
  ] as const;
};

export const getGetUserQueryOptions = <
  TData = Awaited<ReturnType<typeof getUser>>,
  TError = UnauthorizedErrorResponse
>(
  params: GetUserParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetUserQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getUser>>> = ({
    signal,
  }) => getUser(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getUser>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetUserQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUser>>
>;
export type GetUserQueryError = UnauthorizedErrorResponse;

export function useGetUser<
  TData = Awaited<ReturnType<typeof getUser>>,
  TError = UnauthorizedErrorResponse
>(
  params: GetUserParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUser>>,
          TError,
          Awaited<ReturnType<typeof getUser>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUser<
  TData = Awaited<ReturnType<typeof getUser>>,
  TError = UnauthorizedErrorResponse
>(
  params: GetUserParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUser>>,
          TError,
          Awaited<ReturnType<typeof getUser>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUser<
  TData = Awaited<ReturnType<typeof getUser>>,
  TError = UnauthorizedErrorResponse
>(
  params: GetUserParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get user
 */

export function useGetUser<
  TData = Awaited<ReturnType<typeof getUser>>,
  TError = UnauthorizedErrorResponse
>(
  params: GetUserParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetUserQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get users via tenant id (admin)
 */
export const adminGetUsers = (
  params: AdminGetUsersParams,
  signal?: AbortSignal
) => {
  return httpClient<User[]>({
    url: `/admin/query-service/user-information/get-users`,
    method: "GET",
    params,
    signal,
  });
};

export const getAdminGetUsersQueryKey = (params?: AdminGetUsersParams) => {
  return [
    "admin",
    "query-service",
    "user-information",
    "get-users",
    ...(params ? [params] : []),
  ] as const;
};

export const getAdminGetUsersQueryOptions = <
  TData = Awaited<ReturnType<typeof adminGetUsers>>,
  TError = UnauthorizedErrorResponse
>(
  params: AdminGetUsersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminGetUsers>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminGetUsersQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminGetUsers>>> = ({
    signal,
  }) => adminGetUsers(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminGetUsers>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminGetUsersQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminGetUsers>>
>;
export type AdminGetUsersQueryError = UnauthorizedErrorResponse;

export function useAdminGetUsers<
  TData = Awaited<ReturnType<typeof adminGetUsers>>,
  TError = UnauthorizedErrorResponse
>(
  params: AdminGetUsersParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminGetUsers>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminGetUsers>>,
          TError,
          Awaited<ReturnType<typeof adminGetUsers>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useAdminGetUsers<
  TData = Awaited<ReturnType<typeof adminGetUsers>>,
  TError = UnauthorizedErrorResponse
>(
  params: AdminGetUsersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminGetUsers>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminGetUsers>>,
          TError,
          Awaited<ReturnType<typeof adminGetUsers>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useAdminGetUsers<
  TData = Awaited<ReturnType<typeof adminGetUsers>>,
  TError = UnauthorizedErrorResponse
>(
  params: AdminGetUsersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminGetUsers>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get users via tenant id (admin)
 */

export function useAdminGetUsers<
  TData = Awaited<ReturnType<typeof adminGetUsers>>,
  TError = UnauthorizedErrorResponse
>(
  params: AdminGetUsersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminGetUsers>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getAdminGetUsersQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get TPM access for multiple users by email (admin)
 */
export const adminGetUsersAccessByEmail = (
  params: AdminGetUsersAccessByEmailParams,
  signal?: AbortSignal
) => {
  return httpClient<AdminGetUsersAccessByEmail200>({
    url: `/admin/query-service/user-information/get-users-access-by-email`,
    method: "GET",
    params,
    signal,
  });
};

export const getAdminGetUsersAccessByEmailQueryKey = (
  params?: AdminGetUsersAccessByEmailParams
) => {
  return [
    "admin",
    "query-service",
    "user-information",
    "get-users-access-by-email",
    ...(params ? [params] : []),
  ] as const;
};

export const getAdminGetUsersAccessByEmailQueryOptions = <
  TData = Awaited<ReturnType<typeof adminGetUsersAccessByEmail>>,
  TError =
    | BadRequestResponse
    | UnauthorizedErrorResponse
    | ForbiddenErrorResponse
>(
  params: AdminGetUsersAccessByEmailParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof adminGetUsersAccessByEmail>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAdminGetUsersAccessByEmailQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof adminGetUsersAccessByEmail>>
  > = ({ signal }) => adminGetUsersAccessByEmail(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminGetUsersAccessByEmail>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminGetUsersAccessByEmailQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminGetUsersAccessByEmail>>
>;
export type AdminGetUsersAccessByEmailQueryError =
  | BadRequestResponse
  | UnauthorizedErrorResponse
  | ForbiddenErrorResponse;

export function useAdminGetUsersAccessByEmail<
  TData = Awaited<ReturnType<typeof adminGetUsersAccessByEmail>>,
  TError =
    | BadRequestResponse
    | UnauthorizedErrorResponse
    | ForbiddenErrorResponse
>(
  params: AdminGetUsersAccessByEmailParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof adminGetUsersAccessByEmail>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminGetUsersAccessByEmail>>,
          TError,
          Awaited<ReturnType<typeof adminGetUsersAccessByEmail>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useAdminGetUsersAccessByEmail<
  TData = Awaited<ReturnType<typeof adminGetUsersAccessByEmail>>,
  TError =
    | BadRequestResponse
    | UnauthorizedErrorResponse
    | ForbiddenErrorResponse
>(
  params: AdminGetUsersAccessByEmailParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof adminGetUsersAccessByEmail>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminGetUsersAccessByEmail>>,
          TError,
          Awaited<ReturnType<typeof adminGetUsersAccessByEmail>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useAdminGetUsersAccessByEmail<
  TData = Awaited<ReturnType<typeof adminGetUsersAccessByEmail>>,
  TError =
    | BadRequestResponse
    | UnauthorizedErrorResponse
    | ForbiddenErrorResponse
>(
  params: AdminGetUsersAccessByEmailParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof adminGetUsersAccessByEmail>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get TPM access for multiple users by email (admin)
 */

export function useAdminGetUsersAccessByEmail<
  TData = Awaited<ReturnType<typeof adminGetUsersAccessByEmail>>,
  TError =
    | BadRequestResponse
    | UnauthorizedErrorResponse
    | ForbiddenErrorResponse
>(
  params: AdminGetUsersAccessByEmailParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof adminGetUsersAccessByEmail>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getAdminGetUsersAccessByEmailQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const setUserEmail = (
  userId: Id,
  setUserEmail: SetUserEmail,
  signal?: AbortSignal
) => {
  return httpClient<User>({
    url: `/command-service/identity-and-access/aggregate/user/${userId}/set-user-email`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: setUserEmail,
    signal,
  });
};

export const getSetUserEmailMutationOptions = <
  TError = UnauthorizedErrorResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setUserEmail>>,
    TError,
    { userId: Id; data: SetUserEmail },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof setUserEmail>>,
  TError,
  { userId: Id; data: SetUserEmail },
  TContext
> => {
  const mutationKey = ["setUserEmail"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof setUserEmail>>,
    { userId: Id; data: SetUserEmail }
  > = (props) => {
    const { userId, data } = props ?? {};

    return setUserEmail(userId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type SetUserEmailMutationResult = NonNullable<
  Awaited<ReturnType<typeof setUserEmail>>
>;
export type SetUserEmailMutationBody = SetUserEmail;
export type SetUserEmailMutationError = UnauthorizedErrorResponse;

export const useSetUserEmail = <
  TError = UnauthorizedErrorResponse,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof setUserEmail>>,
      TError,
      { userId: Id; data: SetUserEmail },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof setUserEmail>>,
  TError,
  { userId: Id; data: SetUserEmail },
  TContext
> => {
  const mutationOptions = getSetUserEmailMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
